require('jquery/dist/jquery');
require('../app/lib/jquery.resize');
const lodash = require('lodash');
window.lodash = window._ = lodash;
import { DateTime } from "luxon";

window.DateTime = DateTime;
require('angular');
require('chosen-js/chosen.jquery'); // Not in package.json, but still included by angular-chosen
require('angular-chosen-localytics/dist/angular-chosen');
require('angular-ui-router/release/angular-ui-router');
require('angular-gridster/dist/angular-gridster.min');
require('angular-sanitize/angular-sanitize');
require('angular-messages/angular-messages');
require('angular-resource/angular-resource');
require('angular-animate/angular-animate');
require('angularjs-toaster/toaster');
require('angular-translate/dist/angular-translate');
require('angular-ui-bootstrap/dist/ui-bootstrap-tpls');
require('ng-infinite-scroll/build/ng-infinite-scroll');

// Load Highcharts modules.
const Highcharts = require('highcharts/highcharts');
require('highcharts/modules/accessibility')(Highcharts);
require('highcharts/modules/heatmap')(Highcharts);
require('highcharts/modules/xrange')(Highcharts);
require('highcharts/modules/exporting')(Highcharts);
require('highcharts/modules/offline-exporting')(Highcharts);
window.Highcharts = Highcharts;

require('../app/lib/export-csv');
require('../app/lib/validate.min');
require('angular-file-saver/dist/angular-file-saver.bundle');
require('angularjs-slider/dist/rzslider.min');

// Import styles
require('../app/styles/css/font-awesome.min.css');
require('../app/styles/css/bootstrap.min.css');
require('../app/styles/css/bootstrap-theme.min.css');
require('../app/styles/css/toaster.min.css');
require('../app/styles/css/angular-gridster.min.css');
require('../app/styles/css/chosen.min.css');

require('../app/styles/less/less.import');

// React2Angular modules
require('./modules/webtip/index');
require('./modules/gridlets/vale-fleet-info/');
require('./modules/gridlets/car-list-view/car-list-view.component');
require('./modules/gridlets/car-view/car-view.component');
require('./modules/analysis/consist-history/consist-history.component');
require('./modules/condition-monitoring/condition-monitoring-view.component');
require('./modules/gridlets/train-software-status/train-software-status.component');
require('./modules/gridlets/pis-conditions/pis-conditions.component');
require('./modules/layout/main-footer.component');
require('./modules/time-picker/time-picker.component');
require('./modules/data-scope/data-scope.component');
require('./modules/analysis/event-history-table/consist-event-history-table.component');
require('./modules/analysis/event-history-table/event-history-table-mrt.component');
require('./modules/analysis/alarm-notification.service');
require('./modules/analysis/alarm-report-modal.component');
require('./modules/analysis/alarm-rule/alarm-rule-list.component');
require('./modules/analysis/alarm-rule/alarm-rule-view-modal.component');
require('./modules/analysis/alarm-rule/alarm-rule-form-modal.component');
require('./modules/analysis/alarm-event/alarm-event-list.component');
require('./modules/analysis/alarm-event/alarm-event-view-modal.component');
require('./modules/filter-presets/filter-presets.component');
require('./modules/train-info/train-info-panel.component');

// Angular modules
require('./module.init');
require('./modules/analysis/filters-panel.component');
require('./modules/analysis/edit-criteria-panel.component');
require('./modules/analysis/filters/date-filter.component');
require('./modules/analysis/alarm-rule/create-alarm-rule.component');
require('../app/main');


const service_right = {
  SERVICE_LIMIT: 'SERVICE_LIMIT',
  ACCESS_NOTHING: 'ACCESS_NOTHING'
};

const lodashModule = angular.module('lodash', []);
lodashModule.factory('_', ['$window', function ($window) {
  return $window._; // assumes lodash has already been loaded on the page
}]);
angular
  .module('modules', [
    'admin-configuration.module',
    'analysis.module',
    'psa.module',
    'common-directives.module',
    'custom-dashboard.module',
    'dashboard.module',
    'frontpage.module',
    'gridlets-directives.module',
    'login-controllers.module',
    'login-directives.module',
    'configuration-management.module',
    'package-management.module',
    'webtip.module',
    'gridlets.module',
    'users.module',
    'pis-tool.module',
    'access-nothing.module',
    'key-manager.module',
    'track-condition.module',
    'condition-monitoring.module',
    'logo.module'
    // 'chart.module' TODO: Add when migrating to chart component
  ]);
angular.element(document).ready(function () {
  angular.module('eke',
    ['gridster',
      'ngSanitize',
      'ngResource',
      'lodash',
      'ngAnimate',
      'toaster',
      'ngFileSaver',
      'ui.bootstrap',
      'ui.validate',
      'pascalprecht.translate',
      'infinite-scroll',
      'localytics.directives',
      'translations',
      'templates',
      'ekeFilters',
      'rmmServices',
      'userServices',
      'dataServices',
      'alarmServices',
      'eventServices',
      'commonServices',
      'gridletServices',
      'sortingServices',
      'modules',
      'trainControllers',
      'modalControllers',
      'chartDirectives',
      'gridletDirectives',
      'dashboardGridletDirectives',
      'trainGridletDirectives',
      'analysisGridletDirectives',
      'notificationDirectives',
      'modalDirectives',
      'commonModules',
    ]);

  angular.module('infinite-scroll').value('THROTTLE_MILLISECONDS', 300);

  angular.module('eke').config(function ($locationProvider, $stateProvider, $urlRouterProvider, $httpProvider, $translateProvider) {

    $locationProvider.html5Mode({
      enabled: true,
      requireBase: false
    });
    $httpProvider.defaults.withCredentials = true;

    $urlRouterProvider.when('/', '/frontpage').otherwise('/');

    $translateProvider.preferredLanguage('en');
    $translateProvider.fallbackLanguage('en');
    $translateProvider.useSanitizeValueStrategy('escaped');

    $stateProvider
      .state('oss-attribution', {
        url: '/oss-attribution',
        templateUrl: '/modules/common/oss-attribution.html',
      })
      .state('frontpage', {
        url: '/frontpage',
        controller: 'frontPageController',
        templateUrl: '/modules/frontpage/frontpage-module.html',
        resolve: {
          auth: function (userService, $state, eventService) {
            return userService.resolve().then(function () {
              if (userService.isAuthorized()) {
                userService
                  .resolve([service_right.SERVICE_LIMIT])
                  .then(() => {
                    eventService.trigger('userservice:unauthorized');
                    $state.go('service-limit');
                  })
                  .catch(() => {
                    userService
                      .resolve([service_right.ACCESS_NOTHING])
                      .then(() => {
                        eventService.trigger('userservice:unauthorized');
                        $state.go('access-nothing');
                      })
                      .catch(() => {
                        if (userService.hasRight('ACCESS_DASHBOARD')) {
                          $state.go('dashboard');
                        } 
                        // Currently, all the roles except PIS roles (PIS_VIEWER, PIS_EDITOR, PIS_APPROVER, PIS_DEPLOYER)
                        // have ACCESS_DASBOARD. PIS users need to be directed to PIS page after login
                        // All the PIS roles have ACCESS_PIS
                        else if (userService.hasRight('ACCESS_PIS')) { 
                          $state.go('pis.workspaces');
                        }
                      });
                  });
              } else {
                eventService.trigger('userservice:unauthorized');
              }
            });
          },
        },
      })
      .state('dashboard', {
        url: '/dashboard',
        controller: 'dashboardController',
        templateUrl: '/modules/dashboard/dashboard-module.html',
        resolve: {
          auth: function (userService, $state, eventService) {
            userService
              .resolve(['ACCESS_NOTHING'])
              .then(() => {
                eventService.trigger('userservice:unauthorized');
                $state.go('access-nothing');
              })
              .catch(() => {
              });

            return userService.resolve(['ACCESS_DASHBOARD'])
              .then()
              .catch(() => {
                eventService.trigger('userservice:unauthorized');
                $state.go('frontpage');
              });
          },
        },
      })
      .state('dashboard2', {
        url: '/dashboard2',
        controller: 'customDashboardController',
        templateUrl: '/modules/customDashboard/customDashboard-module.html',
        resolve: {
          auth: function (userService, $state, eventService) {
            userService
              .resolve(['ACCESS_NOTHING'])
              .then(() => {
                eventService.trigger('userservice:unauthorized');
                $state.go('access-nothing');
              })
              .catch(() => {
              });

            return userService.resolve(['ACCESS_DASHBOARD']).then(() => {
            })
              .catch(() => {
                eventService.trigger('userservice:unauthorized');
                $state.go('frontpage');
              });
          },
        },
      })
      .state('password-reset', {
        url: '/password-reset/:token',
        controller: 'resetPasswordController',
        templateUrl: '/modules/login/password-template.html',
        resolve: {
          auth: function (userService, $state) {
            return userService.resolve().then(function () {
              if (userService.isAuthorized()) {
                $state.go('dashboard');
              }
            });
          },
        },
      });

    const httpInterceptor = ['$injector', '$q', function ($injector, $q) {

      const toaster = $injector.get('toaster');
      const translate = $injector.get('$translate');

      function isLoginError(response, state) {
        return response.status === 401 || response.status === 403 && state.is('frontpage');
      }

      function isServiceError(response) {
        return response.status === 503;
      }

      function generateErrorToast(title, message) {
        //fallback if $translate hasnt been injected for some reason
        if (!title || title === 'server-error.title' || title === 'service-error.title') {
          title = "500 - Server Error";
          message = "Unexpected condition was encountered on server and everything might not work as expected.";
        }
        toaster.error(title, message);
      }

      function handleLoginError(response, deferred, state) {
        const userService = $injector.get('userService');
        userService.update().then(function () {
          state.go('frontpage');
          deferred.resolve(response);
        }).catch(function () {
          deferred.resolve(response);
        });
      }

      function handleServiceError(response, deferred) {
        const title = translate.instant('service-error.title');
        let message = translate.instant('service-error.message');
        if (response.data.errorType) {
          message = translate.instant('error-type.' + response.data.errorType);
          if (response.data.errorType === 'ANALYSIS_OFFLINE') {
            const eventService = $injector.get('eventService');
            eventService.broadcast('analysis-offline');
          }
        }
        deferred.resolve(response);
      }

      function handleResponse(response) {
        const deferred = $q.defer();
        const $state = $injector.get('$state');
        if (isLoginError(response, $state)) {
          handleLoginError(response, deferred, $state);
        } else if (isServiceError(response)) {
          handleServiceError(response, deferred);
        } else {
          if (response.data) {
            response.data.status = response.status;
          } else {
            response.data = {status: response.status};
          }
          deferred.resolve(response);
        }
        return deferred.promise;
      }

      return {
        responseError: handleResponse
      };
    }];

    $httpProvider.interceptors.push(httpInterceptor);
  });

  angular.module('eke').run(function (userService, $rootScope, $state) {

    userService.update();
    //("runblock")
    //(window);

    // $rootScope._ = window._;

    $rootScope.$on('$stateChangeError', function () {
      $state.go('frontpage');
    });

    window.onbeforeunload = function () {
      //("windowbeforeundload");
      $rootScope.$broadcast('window-refresh');
    };

    window.onresize = function () {
      //("rezise on run");
      $rootScope.$broadcast('window-resize');
    };
  });

  async function bootstrap() {
    const response = await fetch("/env.json");
    const config = await response.json();

    // Environment variables
    const env = {
      enableDebug: true,
      profile: config.profile.toUpperCase(),
      operator: config.operator.toLowerCase(),
      frontendVersion: config.frontendVersion
    };
    window.__env = env;

    angular.module('eke').constant('__env', env);

    angular.module('eke').constant('config', {
      api: "/service/",
      loginURL: config.loginURL,
      socketURL: config.socketURL || window.location.protocol + window.location.host,
      rmmApi: config.rmmApi,
      trackConditionURL: config.trackConditionURL,
      driversViewURL: config.driversViewURL
    });

    angular.bootstrap(document, ['eke']);
  }

  bootstrap();
});
